import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { Helmet } from 'react-helmet';
import * as productConfigs from '../products';

const ProductContext = React.createContext();
const productList = {};

Object.keys(productConfigs).forEach((configName) => {
  productList[productConfigs[configName].productShortName] = productConfigs[configName];
});

export function useProductContext() {
  const eligibility = React.useContext(ProductContext);
  return eligibility;
}

const Product = ({
  inAuthId,
  children,
  locale,
  host,
  selectedProduct,
  productsList,
  sourcecode,
  eligibilityData: eligibilityDataProp,
  isSelected,
}) => {
  const { formatMessage } = useIntl();
  const [productIsSelected, setProductIsSelected] = useState(isSelected);
  const [eligibilityData, setEligibilityData] = useState(eligibilityDataProp);
  let product = {};

  if (productIsSelected && eligibilityData) {
    const { eligibleCards } = eligibilityData;
    let eligibleCardList = [];

    /* istanbul ignore else */
    if (Array.isArray(eligibleCards)) {
      eligibleCardList = eligibleCards.map((card) => card.accountToken);
    }

    if (eligibleCardList.includes(selectedProduct)) {
      [product] = eligibleCards.filter((card) => card.accountToken === selectedProduct);
      const productConfig = productList[product && product.productName];

      if (productConfig) {
        product = {
          ...product,
          ...productConfig,
          ...productsList.CARD_PRODUCT.productsList[selectedProduct],
        };
        if (typeof sourcecode === 'string') {
          product.businessCodes.sourcecode = sourcecode;
        }
        let { productName } = product;
        productName = formatMessage({
          id: productName,
          defaultMessage: productName,
        });
        product.productName = productName;
      }
    }
  }
  return (
    <>
      <ProductContext.Provider
        value={{
          product,
          inAuthId,
          locale,
          host,
          setProductIsSelected,
          setEligibilityData,
          productsList,
          sourcecode,
          eligibilityData,
        }}
      >
        {children}
      </ProductContext.Provider>
      <Helmet title={formatMessage({
        id: 'pageTitle.description',
        defaultMessage: 'pageTitle.description',
      })}
      />
    </>
  );
};
Product.propTypes = {
  inAuthId: PropTypes.string,
  children: PropTypes.node.isRequired,
  locale: PropTypes.string.isRequired,
  host: PropTypes.string.isRequired,
  selectedProduct: PropTypes.string.isRequired,
  productsList: PropTypes.objectOf(PropTypes.object).isRequired,
  sourcecode: PropTypes.string,
  eligibilityData: PropTypes.shape({
    eligibleCards: PropTypes.array.isRequired,
  }),
  isSelected: PropTypes.bool,
};
Product.defaultProps = {
  inAuthId: undefined,
  sourcecode: undefined,
  eligibilityData: null,
};
export default Product;
